import { McpServer } from '@modelcontextprotocol/sdk/server/mcp.js';
import logger from '../utils/logger.js';

/**
 * Register all prompts with the MCP server
 * @param server MCP server instance
 */
export async function registerPrompts(server: McpServer): Promise<void> {
  logger.info('Registering Artillery prompts');
  
  // Prompt for generating a basic HTTP performance test
  server.prompt(
    'generate-basic-http-test',
    'Generate a basic HTTP performance test using Artillery.io',
    () => ({
      messages: [{
        role: 'user',
        content: {
          type: 'text',
          text: 'I need to create a basic HTTP performance test for an API endpoint with Artillery.io. Please help me generate a test configuration for a typical REST API with 5 requests per second for 60 seconds.'
        }
      }]
    })
  );
  
  // Prompt for generating a complex API flow test
  server.prompt(
    'generate-api-flow-test',
    'Generate a complex API flow performance test using Artillery.io',
    () => ({
      messages: [{
        role: 'user',
        content: {
          type: 'text',
          text: 'I need to create a complex API flow performance test using Artillery.io that simulates a sequence of API calls like login, fetch data, and logout. Please help me set up a test that maintains 5 requests per second for 60 seconds.'
        }
      }]
    })
  );
  
  // Prompt for analyzing test results
  server.prompt(
    'analyze-test-results',
    'Analyze Artillery.io performance test results',
    () => ({
      messages: [{
        role: 'user',
        content: {
          type: 'text',
          text: 'I need to analyze Artillery.io test results. Please help me understand the key metrics, identify bottlenecks, and suggest improvements based on typical performance standards.'
        }
      }]
    })
  );
  
  // Prompt for creating a load test plan
  server.prompt(
    'create-load-test-plan',
    'Create a comprehensive load testing plan using Artillery.io',
    () => ({
      messages: [{
        role: 'user',
        content: {
          type: 'text',
          text: 'I need to create a comprehensive load testing plan for a web application. Please help me define what types of tests to run, specific scenarios to implement, how to interpret results, and how to schedule the tests using Artillery.io.'
        }
      }]
    })
  );
  
  logger.info('Artillery prompts registered successfully');
}
